import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditorToolbar, { modules, formats } from "../../utils/EditorToolbar";
import VerticalTabs from "../../utils/Tab/VerticalTabs.js"
import { Button, Box } from "@mui/material";

const Documents = ({ placeholder }) => {
  const [state, setState] = React.useState({ value: null });
  const handleChange = (value) => {
    setState({ value });
  };
  const tabs = [
    {
      label: "Manage Tabs",
      content: (
        <div>
          <form>
            <input type="text" placeholder="tab name"></input>
          </form>
        </div>
      ),
    },
    {
      label: "Privacy & policy",
      content: (
        <div
          className="text-editor"
          style={{ backgroundColor: "white", height: 270 }}
        >
          <EditorToolbar />
          <ReactQuill
            theme="snow"
            value={state.value}
            onChange={handleChange}
            placeholder={"Write something awesome..."}
            modules={modules}
            formats={formats}
            style={{ height: 200 }}
          />
        </div>
      ),
    },
    {
      label: "Terms & Condition",
      content: (
        <div
          className="text-editor"
          style={{ backgroundColor: "white", height: 270 }}
        >
          <EditorToolbar />
          <ReactQuill
            theme="snow"
            value={state.value}
            onChange={handleChange}
            placeholder={"Write something awesome..."}
            modules={modules}
            formats={formats}
            style={{ height: 200 }}
          />
        </div>
      ),
    },
    {
      label: "Refund Policy",
      content: (
        <div
          className="text-editor"
          style={{ backgroundColor: "white", height: 270 }}
        >
          <EditorToolbar />
          <ReactQuill
            theme="snow"
            value={state.value}
            onChange={handleChange}
            placeholder={"Write something awesome..."}
            modules={modules}
            formats={formats}
            style={{ height: 200 }}
          />
        </div>
      ),
    },
    {
      label: "Payment Terms",
      content: (
        <div
          className="text-editor"
          style={{ backgroundColor: "white", height: 270 }}
        >
          <EditorToolbar />
          <ReactQuill
            theme="snow"
            value={state.value}
            onChange={handleChange}
            placeholder={"Write something awesome..."}
            modules={modules}
            formats={formats}
            style={{ height: 200 }}
          />
        </div>
      ),
    },
    {
      label: "Draw Policy",
      content: (
        <div
          className="text-editor"
          style={{ backgroundColor: "white", height: 270 }}
        >
          <EditorToolbar />
          <ReactQuill
            theme="snow"
            value={state.value}
            onChange={handleChange}
            placeholder={"Write something awesome..."}
            modules={modules}
            formats={formats}
            style={{ height: 200 }}
          />
        </div>
      ),
    },
    {
      label: "Group Join T&C",
      content: (
        <div
          className="text-editor"
          style={{ backgroundColor: "white", height: 270 }}
        >
          <EditorToolbar />
          <ReactQuill
            theme="snow"
            value={state.value}
            onChange={handleChange}
            placeholder={"Write something awesome..."}
            modules={modules}
            formats={formats}
            style={{ height: 200 }}
          />
          <Button className="btn">cancel</Button>
          <Button className="btn">Save</Button>
        </div>
      ),
    },
  ];
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flexGrow: 1, p: 3, m: 15 }}>
          <VerticalTabs tabs={tabs} />
        </Box>
      </Box>
    </>
  );
};

export default Documents;
